import * as React from 'react';
import Link from './Link';
import { MdxNextPrevious } from '../types/mdx';

interface Props {
  next?: MdxNextPrevious;
  previous?: MdxNextPrevious;
}

function NextPrevious({ next, previous }: Props) {
  if (!next && !previous) {
    return null;
  }

  return (
    <div className="flex mt-10">
      <div className="w-1/2">
        {!!previous && (
          <Link
            to={previous.fields.slug}
            className="font-thin text-gray-500 hover:underline text-base lg:text-base"
          >{`← ${previous.frontmatter.title}`}</Link>
        )}
      </div>
      <div className="w-1/2 flex justify-end">
        {!!next && (
          <Link
            className="font-thin text-gray-500 hover:underline text-base lg:text-base"
            to={next.fields.slug}
          >{`${next.frontmatter.title} →`}</Link>
        )}
      </div>
    </div>
  );
}

export default NextPrevious;
